import {Injectable} from "@angular/core";
import {Headers, Http, Response} from "@angular/http";
import {Agent, Contract, Permission, Role} from "../models";
import {TreeNode} from "primeng/primeng";
import {Observable} from "rxjs/Observable";
import "rxjs/add/operator/map";
import {AppSettings} from "../app.settings";
import {AgentUtility} from "../util/agent.utility";
import { CountTimer } from "app/services/perfomance.service";
import {ResponseApi} from "./response/response";
import {Base2Service} from "./base2.service";

export class Filter {
    Id:number;
    fio?: string;
    role?: number;
    status?: number;
    page?: number;
    Email?: string;
    ContractLeaderId?: number;
    limit?: any;
    IsBlocked?: boolean;
    onlyEnabled:boolean = true;
    name: any;
    // constructor(public fio?: string, public role?: number, public status?: number, public page?: number) { }
}

export enum EventFilterDate {
    Today,
    Weekly,
    Month,
    Year
}

export enum PSKType{
    All,
    AgentPortfolio,
    PSK
}

export class FilterContracts {
    Id?: number;
    AgentId?: number;
    ProductId?: number;
    Status?: number;
    limit?: any;
    page?: number;
    StartDate?: Date;
    EndDate?: Date;
    excel: boolean = false;
    StatusId?: number;
    agents?: number[];
    PersonId?: number;
    PSKCode: PSKType = PSKType.All;

    // constructor(public fio?: string, public role?: number, public status?: number, public page?: number) { }
}

export class FilterEvents {
    ContractId?: number;
    ContactId?: number;
    Number?: string;
    PersonId?: number;
    PolicyHolder?: string;
    EventDate?: Date;
    EventTypeId?: number = -1000;
    EventType?: string;
    AgentId?: number;
    IsViewed?: boolean;
    ViewedByAgentId?: number;
    limit?: any;
    excel: boolean = false;
    page?: number;
    typeDate: EventFilterDate = EventFilterDate.Weekly;
    deep:boolean = false;
    agents?: number[];
    agentsContract?: number[];
    // constructor(public fio?: string, public role?: number, public status?: number, public page?: number) { }
}
// TODO: Энкодить данные.
@Injectable()
export class HttpService {
    headers: Headers;
 
    constructor(private http: Http, private _countTimer : CountTimer, private _base2:Base2Service) {
        this.headers = new Headers({'content-type': 'application/json'});
        this.headers.append('Accept', 'Authorization');
    }


    getAgent(id: number): Observable<any> {

        return this.http.get(AppSettings.apiUrl + 'agents/' + id, {headers: this.headers})
            .map((resp: Response) => {
                let agentData = resp.json().data;
                // let agent: Agent = new Agent;
                // agent.Id = agentData.Id;
                // agent.Name = agentData.Name;
                // agent.FirstName = agentData.FirstName;
                // agent.MiddleName = agentData.MiddleName;
                // agent.createdAt = agentData.createdAt;
                // agent.roleId = agentData.RoleId;
                // agent.PhotoURL = agentData.PhotoURL;
                return agentData;
            });
    }
}
